import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HowToTextPage } from './how-to-text.page';

const routes: Routes = [
  {
    path: '',
    component: HowToTextPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HowToTextPageRoutingModule {}
